import React, { Component } from 'react';
import {SideBar, SideBarHead, SideList, SideListItemGeneric} from 'app/components/SideBar/';
import RegionForm from './RegionForm';
import NewRegion from './RegionModel';
import RegionHome from './components/RegionHome/RegionHomeComponent';
import RegionService from "../../../services/region.service";
import  GetErrorMessage  from '../../../helpers/error-message'
import {ShowError, ShowSuccess} from "../../../components/toast"
import { Loading } from '@ecosystem/ui-lib/core/components/Loading';
import {BlockUi} from 'app/components/Basics/';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import Modal from '../../../components/Modal';
import { Button } from 'app/components/Basics/'
import { ReactComponent as PagesIcon } from 'app/assets/icons/pagepage.svg';
import './RegionComponent.scss';

class Region extends Component {
	constructor (props) {
	super(props);
		this.state = {
			search: '',			
			allData: [],
			filteredData: [],
			folders: [],
			loading: false,
			errorMessage: null,
			selectedRegion: null,
			originalSelectedRegion: null,
			uiBlocked: false,
			editorOpen: false,			
			metadata: {
				permissions: []
			}
		}		
	}

	setSearchState(event) {    
		var value = event.target.value;    
		this.setState({search: value});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.search !== prevState.search) {     
			this.filterRegions(this.state.search);
		}

		if (this.state.editorOpen !== prevState.editorOpen) {
			if (this.state.editorOpen) {
			//retrigger selected question if editor was closed        
			this.setState({selectedRegion: this.state.selectedRegion});
			}
		}    
	}

	filterRegions(term) {		
		if (term !== '') {
			const filteredData = this.state.allData
			.filter(i => (i.name  && i.name.toLowerCase().includes(term.toLowerCase())));
			let newFilteredData = [...filteredData];
			this.setState({ filteredData: newFilteredData});      
		}
		else {
			let newFilteredData = [...this.state.allData];
			this.setState({ filteredData: newFilteredData});     
		}
	}

	componentDidMount() {		
		this.queryMetadata();
		this.queryRegions('');
	}	

	openEditor() {
		this.setState({editorOpen: true});		
	}	

	closeEditorButtonOnClick() {
		if (this.shouldLosePossibleChangesOnEditor(this.closeEditor)) {
			this.closeEditor();
		}
	}

	closeEditor() {
		this.setState({ editorOpen: false });
		this.setSelectedItem(null);
	}

	queryMetadata() {		
		RegionService.getMetadata()
				.then(response =>{					
					this.setState({
						metadata: response.data					
					});
					return response;          
				})
				.catch(error => {			  
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}	

	queryRegions(term) {
		this.setState({ loading: true, filteredData: [] });
		RegionService.find(term)
			.then(response =>{				
				this.setState({ filteredData: response.data,
					allData:  response.data,					
					loading: false				
				}, function() { this.filterRegions(this.state.search); });
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	getRegionById(id) {		
		this.toggleUiBlock(true)
		RegionService.getRegionById(id)
			.then(response =>{
				this.setState({originalSelectedRegion: cloneDeep(response.data)});
				this.updateSelectedRegion(response.data);
				this.updateSavedRegionOnList(response.data);				
				this.toggleUiBlock(false)
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ errorMessage: errorMessage});    
				this.toggleUiBlock(false)        
			})
	}	

	getSelectedItem(regionId) {		
		this.setState({clickedRegionId: regionId});		
		this.openEditor();
		if (this.shouldLosePossibleChangesOnEditor(()=>this.getRegionById(regionId))) {			
			this.getRegionById(regionId)			
		}	
	}

	setSelectedItem(selectedRegion) {		
		this.updateSelectedRegion(selectedRegion);
	}	

	shouldLosePossibleChangesOnEditor(callbackAfterLoseChangesConfirmation) {		
		if (this.didSelectedRegionChange()) {
			this.showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation);
			return false;	
		}
		else {	
			return true;
		}	
	}

	didSelectedRegionChange() {
		let selectedRegion = this.state.selectedRegion;
		if (!selectedRegion) return false;
		return !isEqual(selectedRegion, this.state.originalSelectedRegion);		
	  }

	showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation) {
		this.setState({ 
			loseChangesModalText: `There are unsaved changes to the region '${this.state.selectedRegion.name}'. Are you sure do you want to leave without saving?`,
			callbackAfterLoseChangesConfirmation: callbackAfterLoseChangesConfirmation
		});
	}

	confirmLoseChangesModalHandler() {
		let filteredData = this.rollbackToOriginalRegion(this.state.filteredData, this.state.originalSelectedRegion);
		let allData = this.rollbackToOriginalRegion(this.state.allData, this.state.originalSelectedRegion);	

		this.setState({allData: allData, filteredData: filteredData
		}, this.state.callbackAfterLoseChangesConfirmation);
		this.setState({clickedRegionId: null});
		this.hideLoseChangesModal();
	}

	rollbackToOriginalRegion(list, originalSelectedItem) {
		const index = list.findIndex(item => item.id === this.state.selectedRegion.id);	
		list[index] = originalSelectedItem;
		return list;
	}

	hideLoseChangesModal() {
		this.setState({loseChangesModalText: ''})
	}

	isItemSelected(regionId) {    
		if (this.state && this.state.selectedRegionSet && 
			this.state.selectedRegion.id === regionId) {
			return true;
		} else {
			return false;
		}
	}

	toggleUiBlock(blockUi) {
		this.setState ({uiBlocked: blockUi});
	} 

	addNewRegionHandler = event => {
		if (this.shouldLosePossibleChangesOnEditor(() => this.addNewRegion())) {
			this.addNewRegion()
		}    
		event.preventDefault();
	}

	addNewRegion() {
		const newRegion = NewRegion();		
		this.setSelectedItem(null);
		this.setSelectedItem(newRegion);
		this.openEditor();
	}

	removeDeletedRegion(regionId) {    
		const newFilteredData = this.state.filteredData.filter(i => i.id !== regionId);
		const newAllData = this.state.allData.filter(i => i.id !== regionId);
		this.setState({ filteredData: newFilteredData,
			allData: newAllData
			});    
	}

	updateSavedRegionOnList(selectedRegion) {
		let newFilteredData = [...this.updateRegionList(this.state.filteredData, selectedRegion)];	
		let newAllData = [...this.updateRegionList(this.state.allData, selectedRegion)];
		this.setState({filteredData: []});
		this.setState({filteredData: newFilteredData, 
			allData: newAllData
		});
	}

	updateRegionList(list, selectedRegion) {		
		var index = list.findIndex(q => q.id === selectedRegion.id);
		if (index === -1) {
			list.push(selectedRegion);      
		}
		else {
			list[index] = selectedRegion;      
		}
		return list;
	}
	
	getListItems() {
		return this.state.filteredData.map(region => 
			<div key={region.id}>
				<SideListItemGeneric key={region.id}
					id={region.id}					
					getSelectedItem={this.getSelectedItem.bind(this)}				
					isItemSelected={this.isItemSelected(region.id)}
					menuItemId={region.id}
				>
					{region.name}
				</SideListItemGeneric>
		</div>
		)
	}

	updateSelectedRegion(selectedRegion) {		
		this.setState({selectedRegion: selectedRegion})
	}	

    render() {

        return (
			<BlockUi blocking={this.state.uiBlocked}>  
			<main className="app-body regions">         
				<div className={`${this.props.isSurveyTest ? "survey-test-sidebar" : ""}`}>
					<SideBar>
						<SideBarHead  canChangeData={this.props.userPermissions?.CanChangeRegion} tagName="SideBarHead" headline="Region" addButton addButtonLabel="Region" addButtonCallBack={this.addNewRegionHandler.bind(this)}
							onChange={this.setSearchState.bind(this)}
						/>                  
						<SideList tagName="SideList">                  
							<Loading active={this.state.loading}></Loading>							
							<div>								
								{this.getListItems()}
							</div>
						</SideList>					
					</SideBar>
				</div>          

				<div className="app-content scrollbox">
					{this.state.editorOpen && ( <RegionForm openEditor={this.openEditor.bind(this)} 
							didSelectedRegionChange={this.didSelectedRegionChange.bind(this)}
							closeEditorButtonOnClick={this.closeEditorButtonOnClick.bind(this)} 
							closeEditor={this.closeEditor.bind(this)}
							removeDeletedRegion={this.removeDeletedRegion.bind(this)} 
							toggleUiBlock={this.toggleUiBlock.bind(this)} 
							selectedRegion={this.state.selectedRegion}
							updateSelectedRegion={this.updateSelectedRegion.bind(this)}
							updateSavedRegionOnList={this.updateSavedRegionOnList.bind(this)}
							getRegionById={this.getRegionById.bind(this)}							
							canChangeData={this.props.userPermissions?.CanChangeRegion}
							metadata={this.state.metadata}
							/> )}
					{!this.state.editorOpen && ( <RegionHome></RegionHome>)}					
				</div>				
				
				{this.state.successMessageFolder && ( <ShowSuccess clearMessage={() => this.setState({successMessageFolder: ''})} message={this.state.successMessageFolder} /> )}
				{this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
				{this.state.loseChangesModalText && ( <Modal size="small" content={this.state.loseChangesModalText} confirmModalHandler={this.confirmLoseChangesModalHandler.bind(this)} cancelModalHandler={this.hideLoseChangesModal.bind(this)} />)}
			</main>
			</BlockUi>
        );
    }
}

export default Region;